import { Link } from "react-router-dom";
import { Button } from "@mui/material";

export const LinkButton = ({ to, label }: { to: string; label: string }) => (
  <Link to={to}>
    <Button variant="contained">{label}</Button>
  </Link>
);
